<template>
  <div class="content">
    <div class="main">
      <!-- 导航栏 -->

      <headerNavbar title="体检报告" />
      <!-- 标签页 -->
      <van-tabs v-model="activeTabIndex" sticky>
        <van-tab title="主检结论">
          <!-- 主检结论 -->
          <div class="box1">
            <div class="summary-header" @click="showSummary = !showSummary">
              <img src="../../assets/images/report-doctor.png" />
              <div>
                <h3>总检建议</h3>
                <p>综合各项目给出的的建议与指导</p>
              </div>
              <div class="summary-header-right">
                <van-icon name="arrow-down" v-if="!showSummary" />
                <van-icon name="arrow-up" v-else />
              </div>
            </div>

            <div v-if="showSummary" class="summary-content">
              <!-- 综述 -->
              <div>
                <span class="summary-title">报告综述</span>
                <div class="line"></div>
                <div v-if="reportData.summary==''">
                  <div class="summary-text" v-html="flag===false?'查询中...':'暂无数据'"></div>
                </div>
                <div class="summary-text" v-html="reportData.summary" v-else></div>
              </div>
              <!-- 建议 -->
              <div>
                <span class="summary-title">体检建议</span>
                <div class="line"></div>
                <div class="clum1">
                  <div v-if="reportData.advice==''">
                    <div class="summary-text" v-html="flag===false?'查询中...':'暂无建议'"></div>
                  </div>
                  <div class="summary-text" v-html="reportData.advice" v-else></div>
                </div>
              </div>
            </div>

            <!-- 新增的审核医生、时间 -->
            <ul class="poll" v-if="isshowdoctor">
              <li class="special" v-if="msg.chiefDoctorName?(msg.verifyDoctorName?true:false):false">
                <p>
                  <span>审核医生:{{msg.verifyDoctorName}}</span>
                  <span>审核时间:{{msg.verifyTime}}</span>
                </p>
              </li>

              <li class="special" v-if="msg.chiefDoctorName?true:false">
                <p>
                  <span>总检医生:{{msg.chiefDoctorName}}</span>
                  <span>总检时间:{{msg.reportTime}}</span>
                </p>
              </li>
            </ul>
          </div>
        </van-tab>
        <van-tab title="体格检查">
          <!-- 体格检查 -->
          <div class="item-container">
            <div class="item-row" v-for="(item,index) in checkItems" :key="index">
              <div class="item-header">
                {{item.item_name}}
                <span class="checkdocs" v-if="isshowdoctor">检查医生：{{item.exam_doc_name}}</span>
              </div>
              <ul>
                <li v-for="(its,index) in item.result" :key="index" class="idx_row">
                  <div class="idx_name">{{its.node_name}}</div>
                  <div class="idx_result">
                    <div>
                      <i :class="its.prompt!=''?'overstand':''">{{its.node_result}}</i>
                    </div>
                    <div class="idx_ref_range">
                      <i v-if="its.ref_value!=''">{{'参考值：'+its.ref_value+''}}</i>
                      <i v-if="its.unit!=''" style="color:#c9c5c6">{{'('+its.unit+')'}}</i>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="item-footer">
                <div class="item-footer--title">科室小结</div>
                <pre class="item-footer--content">{{item.comment}}</pre>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="检验项目">
          <!-- 检验项目 -->
          <div class="item-container">
            <div class="item-row" v-for="(item,index) in labItems" :key="item.index">
              <div class="item-header">
                {{item.item_name}}
                <span class="checkdocs" v-if="isshowdoctor">检查医生：{{item.exam_doc_name}}</span>
              </div>
              <ul>
                <li v-for="(its,index) in item.result" :key="index" class="idx_row">
                  <div class="idx_name">{{its.node_name}}</div>
                  <div class="idx_result">
                    <div>
                      <i :class="its.status==1?'overstand':its.status==2?'bottomstand':''">{{its.node_result}}
                        {{its.prompt}}</i>
                    </div>
                    <div class="idx_ref_range">
                      <i v-if="its.ref_value!=''">{{'参考值：'+its.ref_value+''}}</i>
                      <i v-if="its.unit!=''" style="color:#c9c5c6">{{'('+its.unit+')'}}</i>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="line" v-if="item.tips==true?true:inx==index?item.tag:false"></div>
            </div>
          </div>
        </van-tab>
        <van-tab title="影像检查">
          <!-- 影像检查 -->
          <div class="item-container">
            <div class="item-row" v-for="(risReport,index) in risReports" :key="risReport.repno">
              <div class="item-header">
                {{risReport.report_name}}
                <span class="checkdocs" v-if="isshowdoctor">检查医生：{{risReport.exam_doc_name}}</span>
              </div>
              <div class="idx_row" v-if="risReport.finding!=''">
                <div class="idx_name idx_ris_name">检查所见</div>
                <div class="risReport_result">{{risReport.finding}}</div>
              </div>
              <div class="idx_row" v-if="risReport.conclusion!=''">
                <div class="idx_name idx_ris_name">检查结论</div>
                <div class="risReport_result">{{risReport.conclusion}}</div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  import
  headerNavbar
  from '../components/headerNavbar'
  import * as api_report from "@/api/report"
  export default {
    components: {
      headerNavbar
    },
    data() {
      return {
        imgShow: false,
        imgData: "",
        flag: false,
        showSummary: true,
        info: "",
        suggestion: "",
        summary: "",
        healthPrescription: "",
        title: "",
        msg: "",
        inx: "",
        tag: false,
        examNo: "",
        uid: "",
        ispdf: false,
        isshowdoctor: false,
        activeTabIndex: 0,
        reportData: Object, //体检报告数据
        checkItems: [], //常规检查
        labItems: [], //检验项目
        risReports: [] //检查报告
      };
    },
    mounted() {
      let repid = this.$route.query.repid;
      let _this = this;
      api_report.getReport(repid).then(resp => {
        _this.reportData = resp.data;
        _this.reportData.summary = _this.formatText(_this.reportData.summary);
        _this.reportData.advice = _this.formatText(_this.reportData.advice);

        _this.checkItems = _this.reportData.items.filter(i => i.item_type === 0);
        _this.labItems = _this.reportData.items.filter(i => i.item_type === 2);
        _this.risReports = _this.reportData.risReports;
      }).catch(err => {

      })
    },

    methods: {
      // 格式化文本
      formatText(content) {
        return content.replace(/\n|\r\n/g, "<br/>");
      },
      getMore(i) {
        // console.log(i)
        this.$forceUpdate();
        this.msg.labReports[this.inx].labIndexes[i].show = !this.msg.labReports[
          this.inx
        ].labIndexes[i].show;
      },
      back() {
        this.$router.go(-1);
      }
    }
  };
</script>
<style lang="less" scoped>
  .imgbtnicon {
    transform: rotate(180deg);
  }

  .summary-header {
    display: flex;
    padding: 16px;
    text-align: left;

    img {
      height: 64px;
      margin-right: 12px;
    }

    h3 {
      color: #138cdd;
      margin-bottom: 12px;
      font-size: 20px;
    }

    p {
      font-weight: 600;
      color: #666666;
    }

    .summary-header-right {
      flex: 1;
      line-height: 60px;
      text-align: right;
    }
  }

  .summary-content {
    .summary-title {
      font-size: 20px;
      line-height: 32px;
      margin: 16px;
      display: block;
    }

    .summary-text {
      font-size: 14px;
      padding: 16px;
      line-height: 24px;
      white-space: pre-wrap;
    }
  }

  .item-container {
    background-color: #f2f3f4;
  }

  .item-row {
    background-color: #fff;
    margin: 16px 0px;
    padding: 16px 16px;
  }

  .item-header {
    text-align: left;
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }

  .item-header span {
    margin: 0;
    padding: 0;
  }

  .item-footer {
    padding: 8px 0;
    border-top: 1px solid #e9e9e9;
    font-size: 14px;

    .item-footer--title {
      font-size: 16px;
      line-height: 32px;
    }

    .item-footer--content {
      line-height: 24px;
    }
  }

  .idx_row {
    text-align: left;
    line-height: 36px;
    border-top: 1px solid #e9e9e9;
    display: flex;
    padding: 8px 0px;
  }

  .idx_name {
    font-size: 14px;
    text-align: left;
    width: 160px;
    margin: 0px !important;
  }

  .idx_ris_name {
    width: 100px;
    line-height: 28px;
  }

  .idx_result {
    font-size: 14px;
    text-align: left;
    line-height: 20px;
    flex: 1;
    display: flex;
    box-pack: center;
    box-orient: vertical;
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-orient: vertical;
  }

  .idx_ref_range {
    font-size: 13px;
    color: #aaaaaa;
  }

  .risReport_result {
    font-size: 14px;
    text-align: left;
    flex: 1;
    line-height: 28px;
  }

  .cur {
    color: #138cdd;
  }

  .active {
    color: #138cdd;
    border-bottom: 3px solid;
  }

  .act {
    color: #138cdd;
  }

  .trant {
    transform: rotate(180deg);
  }

  .current {
    background: #f7f7f7;
  }

  .stand {
    background: #ffe2e7;
  }

  .overstand {
    color: #ff4123;
  }

  .bottomstand {
    color: #e66c5f;
  }

  .line {
    //   width: 100%;
    height: 1px;
    background: #e5e5e5;
    margin: 0px 16px;
  }

  i.rightcont {
    display: inline-block;
    width: 3.9rem;
    text-align: left;
  }

  .content {
    height: 100%;
    background: #f1f1f1;

    .header {
      height: 0.86rem;
      line-height: 0.86rem;
      padding-left: 0.32rem;
      background: #ddd;

      p {
        margin: 0;

        span {
          font-size: 0.33rem;
          color: #000;

          img {
            width: 0.3rem;
            height: 0.3rem;
            vertical-align: middle;
          }
        }

        .left {
          margin-left: 2.3rem;
        }
      }
    }

    .main {
      background: #fff;

      // margin-bottom: 0.8rem;
      .nav-header {
        position: fixed;
        top: 0px;
        height: 32px;
        z-index: 999;
        display: flex;
        width: 100%;
        max-width: 480px;
        background-color: #fff;
        padding: 12px 12px 0px 12px;
        font-size: 16px;
        text-align: center;
      }

      .tabar {
        position: fixed;
        top: 32px;
        height: 48px;
        width: 100%;
        max-width: 480px;
        text-align: center;
        display: flex;
        background-color: #fff;
        z-index: 999;
        box-sizing: border-box;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);

        div {
          padding: 12px 0px;
        }

        span {
          font-size: 16px;
          display: inline-block;
          padding-bottom: 12px;
        }
      }

      .report-wrapper {}

      .box1 ul li {
        p {
          margin: 0;
          display: flex;
          justify-content: space-between;

          span {
            line-height: 1rem;
            font-size: 0.32rem;

            img {
              width: 0.3rem;
              height: 0.2rem;
              vertical-align: middle;
            }
          }
        }
      }

      .space {
        height: 0.5rem;
        background: #f1f1f1;
      }

      .special {
        background: #f1f1f1;

        span {
          margin: 0px 3px;
          color: #999;
          line-height: 0.6rem !important;
          display: inline-block;
        }
      }

      .box2>ul>li {
        #warning {
          display: inline-block;
          padding: 0.23rem 0.12rem;
          line-height: 0rem;
          margin: 0;
          margin: 0 0.2rem;
          font-size: 0.26rem;
          border: 1px solid #f48478;
          border-radius: 0.5rem;
          color: #f48478;
        }

        p {
          margin: 0;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #e9e9e9;

          span {
            font-size: 0.35rem;
            text-align: left;

            img {
              width: 0.35rem;
              height: 0.25rem;
              vertical-align: middle;
            }
          }

          .checkdocs {
            display: inline-block;
            line-height: 0.5rem;
            font-size: 0.28rem;
          }

          .lineight {
            line-height: 0.3rem;
            display: inline-block;
          }
        }

        ul {
          background: #fff;

          li {
            p.its_container {
              padding-left: 0.6rem;
              border-bottom: 0 none;

              span.idx_name {
                width: 2.5rem;
                margin: 0.15rem 0;
                text-align: left;
                line-height: 1;
                font-size: 16px;
                vertical-align: middle;
              }

              span .idx_result {
                font-size: 16px;
              }
            }

            .text {
              width: 2rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 0.28rem;
            }

            .textinfo {
              width: 5rem;
              height: auto;
              text-align: right;
              font-size: 16px;
              display: inline-block;
              line-height: 0.3rem;
              padding: 0.2rem;
            }
          }
        }
      }

      .clum1 {
        padding: 0.2rem 0.3rem;
        text-align: left;

        h3 {
          margin: 0;
        }

        p {
          margin: 0;
        }
      }

      .clum2 {
        padding: 0.2rem 0.3rem;
        text-align: left;
        padding-bottom: 1rem;

        h3 {
          margin: 0;
        }

        p {
          margin: 0;
        }
      }
    }

    #btn {
      position: fixed;
      bottom: 0;
      left: 0;
    }
  }
</style>